module.exports = __webpack_public_path__ + "static/media/10endeudamiento.5f7881b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/10endeudamiento.mp4
// module id = 718
// module chunks = 1